 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import FRONT from '@/components/front'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import COPY from '@/components/copy'
 import TOC from '@/components/toc'
 import SERIES from '@/components/series'
 import ACK from '@/components/ack'
 import ITR from '@/components/itr'
 import PART1 from '@/components/part1'
 import CHAP1 from '@/components/chap1'
 import CHAP2 from '@/components/chap2'
 import CHAP3 from '@/components/chap3'
 import CHAP4 from '@/components/chap4'
 import CHAP5 from '@/components/chap5'
 import PART2 from '@/components/part2'
 import CHAP6 from '@/components/chap6'
 import CHAP7 from '@/components/chap7'
 import CHAP8 from '@/components/chap8'
 import CHAP9 from '@/components/chap9'
 import PART3 from '@/components/part3'
 import CHAP10 from '@/components/chap10'
 import CHAP11 from '@/components/chap11'
 import CHAP12 from '@/components/chap12'
 import CHAP13 from '@/components/chap13'
 import FRONTISPIECES from '@/components/frontispieces'
 import FRONTISPIECES1 from '@/components/frontispieces1'
 import LOVE_2 from '@/components/love_2'
 import BIB from '@/components/bib'
 import CONTRI from '@/components/contri'
 import INDEX from '@/components/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/series",
 			"name" : "series",
 			"component" : SERIES
 		},
 		{
 			"path" : "/ack",
 			"name" : "ack",
 			"component" : ACK
 		},
 		{
 			"path" : "/itr",
 			"name" : "itr",
 			"component" : ITR
 		},
 		{
 			"path" : "/part1",
 			"name" : "part1",
 			"component" : PART1
 		},
 		{
 			"path" : "/chap1",
 			"name" : "chap1",
 			"component" : CHAP1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js